import { render } from "./ScriptTagOutput.vue?vue&type=template&id=ee7cee64&ts=true"
import script from "./ScriptTagOutput.vue?vue&type=script&lang=ts"
export * from "./ScriptTagOutput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__